import { MemoryCache, setCache } from '@ms/yammer-data/dist/cache';

export type SetupCache = () => void;

export const setupCache: SetupCache = () => {
  setCache(new MemoryCache());
};
